import { Link } from "react-router-dom";
import { Mail, Globe, Instagram, ArrowRight } from "lucide-react";
import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("You're on the list — thoughtful notes coming your way.");
      setEmail("");
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer data-testid="site-footer" className="bg-navy text-ivory mt-8">
      <div className="container-editorial pt-24 lg:pt-28 pb-16 lg:pb-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <span className="block w-12 h-px bg-gold mb-6" />
            <p className="overline text-gold/90 mb-6">Begin Here</p>
            <p className="font-serif text-2xl md:text-[1.75rem] lg:text-[2rem] leading-[1.22] max-w-md">
              Strategy isn't just about your business. It's about the{" "}
              <em className="font-serif italic text-gold">life you're building.</em>
            </p>
            <form onSubmit={submit} className="mt-10 flex items-center gap-3 max-w-md border-b border-ivory/30 pb-3" data-testid="footer-newsletter-form">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                data-testid="footer-newsletter-input"
                className="flex-1 bg-transparent text-ivory placeholder:text-ivory/50 focus:outline-none py-2 font-sans"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="footer-newsletter-submit"
                className="font-ui uppercase tracking-[0.18em] text-[11px] text-gold hover:text-ivory transition-colors flex items-center gap-2"
              >
                {loading ? "..." : "Join"} <ArrowRight className="w-3.5 h-3.5" />
              </button>
            </form>
            <p className="font-sans text-[13px] text-ivory/65 mt-3">Thoughtful reflections on strategy, systems & calm growth. No noise.</p>
          </div>

          <div className="md:col-span-2">
            <p className="overline text-gold mb-5">Explore</p>
            <ul className="space-y-3 font-sans text-[14px]">
              <li><Link to="/" data-testid="footer-link-home" className="text-ivory/90 hover:text-gold transition-colors">Home</Link></li>
              <li><Link to="/about" data-testid="footer-link-about" className="text-ivory/90 hover:text-gold transition-colors">About</Link></li>
              <li><Link to="/services" data-testid="footer-link-services" className="text-ivory/90 hover:text-gold transition-colors">Services</Link></li>
              <li><Link to="/resources" data-testid="footer-link-resources" className="text-ivory/90 hover:text-gold transition-colors">Resources</Link></li>
              <li><Link to="/success-stories" data-testid="footer-link-success" className="text-ivory/90 hover:text-gold transition-colors">Success Stories</Link></li>
              <li><Link to="/blog" data-testid="footer-link-blog" className="text-ivory/90 hover:text-gold transition-colors">Blog</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="overline text-gold mb-5">Services</p>
            <ul className="space-y-3 font-sans text-[14px]">
              <li className="text-ivory/90">Revenue Leak Audit</li>
              <li className="text-ivory/90">Strategy Intensive</li>
              <li className="text-ivory/90">Monthly Advisory</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-gold mb-5">Connect</p>
            <ul className="space-y-3 font-sans text-sm">
              <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-gold" /> hello@sarahatkinsonadvisory.com</li>
              <li className="flex items-center gap-3"><Globe className="w-4 h-4 text-gold" /> sarahatkinsonadvisory.com</li>
              <li className="flex items-center gap-3"><Instagram className="w-4 h-4 text-gold" /> @sarahatkinsonadvisory</li>
            </ul>
            <div className="mt-8 border-l-2 border-gold pl-4">
              <p className="font-serif italic text-ivory/90 text-sm leading-relaxed">
                Helping Airbnb owners create businesses that perform better and give them freedom.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-ivory/15 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-ui text-[12px] uppercase tracking-[0.2em] font-medium text-ivory/70">
            © {new Date().getFullYear()} Sarah Atkinson Advisory · Airbnb Consulting & STR Strategy
          </p>
          <p className="font-serif italic text-gold text-lg md:text-xl">Clarity creates confidence.</p>
        </div>
      </div>
    </footer>
  );
}
